if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-drawer') ||
          document.querySelector('cart-notification');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }


      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;


        this.handleErrorMessage();
        this.error = false;


        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');


        const formData = new FormData(this.form);


        // ==========================
        // STOCK CHECK
        // ==========================

        const variantId = formData.get('id');

        const quantityInput = this.form.querySelector('[name="quantity"]');
        const quantity = quantityInput ? Number(quantityInput.value) : 1;


        try {

          const variantResponse = await fetch(`/variants/${variantId}.js`);
          const variant = await variantResponse.json();


          if (!variant.available) {

            this.error = true;

            this.handleErrorMessage(
              '❌ Ky produkt nuk ka stok.'
            );

            this.removeLoadingState();

            return;

          }


          if (quantity > variant.inventory_quantity) {

            this.error = true;

            this.handleErrorMessage(
              `⚠️ Nuk ka kaq produkte në stok. Sasia në dispozicion: ${variant.inventory_quantity}`
            );

            this.removeLoadingState();

            return;

          }


        } catch(error) {

          console.log(
            'Inventory check error:',
            error
          );

        }



        // ==========================
        // CART DRAWER SECTIONS
        // ==========================

        if (this.cart) {

          formData.append(
            'sections',
            this.cart
              .getSectionsToRender()
              .map((section) => section.id)
          );


          formData.append(
            'sections_url',
            window.location.pathname
          );


          this.cart.setActiveElement(
            document.activeElement
          );

        }



        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] =
          'XMLHttpRequest';

        delete config.headers['Content-Type'];

        config.body = formData;



        fetch(`${routes.cart_add_url}`, config)

          .then((response) => response.json())


          .then((response) => {


            if (response.status) {

              publish(
                PUB_SUB_EVENTS.cartError,
                {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors:
                    response.errors ||
                    response.description,
                  message:
                    response.message,
                }
              );


              this.handleErrorMessage(
                response.description
              );


              this.error = true;

              return;

            }



            if (!this.cart) {

              window.location =
                window.routes.cart_url;

              return;

            }



            const startMarker =
              CartPerformance.createStartingMarker(
                'add:wait-for-subscribers'
              );



            if (!this.error) {

              publish(PUB_SUB_EVENTS.cartUpdate, {

                source: 'product-form',

                productVariantId:
                  formData.get('id'),

                cartData:
                  response,

              }).then(() => {

                CartPerformance.measureFromMarker(
                  'add:wait-for-subscribers',
                  startMarker
                );

              });

            }



            this.error = false;



            CartPerformance.measure(
              "add:paint-updated-sections",
              () => {

                this.cart.renderContents(
                  response
                );

              }

            );


          })


          .catch((error) => {

            console.error(error);

          })


          .finally(() => {

            this.removeLoadingState();

          });


      }



      removeLoadingState() {

        this.submitButton.classList.remove(
          'loading'
        );


        if (
          this.cart &&
          this.cart.classList.contains('is-empty')
        ) {

          this.cart.classList.remove(
            'is-empty'
          );

        }


        this.submitButton.removeAttribute(
          'aria-disabled'
        );


        const spinner =
          this.querySelector(
            '.loading__spinner'
          );


        if (spinner) {

          spinner.classList.add(
            'hidden'
          );

        }

      }



      handleErrorMessage(errorMessage = false) {

        if (this.hideErrors) return;


        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );


        if (!this.errorMessageWrapper) return;


        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );


        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );


        if (errorMessage) {

          this.errorMessage.textContent =
            errorMessage;

        }

      }



      get variantIdInput() {

        return this.form.querySelector(
          '[name=id]'
        );

      }

    }
  );
}